import React from 'react';

const DonateFooter = () => {
  return (
    <footer className="site-footer-two site-footer-three">
      <div className="container">
        <div className="site-footer-two__content-and-social-box">
          <div className="site-footer-two__content-shape-1">
            <img src="assets/images/shapes/site-footer-two-content-shape-1.png" alt="" />
          </div>
          <div className="site-footer-two__content-img">
            <img src="assets/images/1.jpg" alt="Rayyan Aid" style={{ width: '160px', height: '160px', objectFit: 'cover' }} />
          </div>
          <h3 className="site-footer-two__content-title">We are a non‑profit charity <span>serving</span> with dignity
          </h3>
          <p className="site-footer-two__content-text">Your generosity fuels education, healthcare, clean water and emergency relief. Together we create lasting change with transparency and impact.</p>

          <div className="donate-two__btn-box">
            <a href="/donate-now" className="thm-btn">
              <span className="thm-btn-text">Donate Now</span>
              <span className="thm-btn-icon-box"><i className="fas fa-arrow-right"></i></span>
            </a>
          </div>
        </div>
      </div>
      <div className="site-footer-two__top">
        <div className="site-footer-two__bg" style={{ backgroundImage: 'url(assets/images/17.jpeg)' }}></div>
        <div className="site-footer-two__shape-1 float-bob-y">
          <img src="assets/images/shapes/site-footer-two-shape-1.png" alt="" />
        </div>
        <div className="container">
          <div className="site-footer-two__top-inner">
            <div className="row">
              <div className="col-xl-4 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="100ms">
                <div className="footer-widget-two__about">
                  <div className="footer-widget-two__about-logo">
                    <a href="/"><img src="assets/images/Rayyan Aid Logo-03.jpg" alt="Rayyan Aid" style={{ height: '60px', width: 'auto' }} /></a>
                  </div>
                  <p className="footer-widget-two__about-text">Support communities in Nigeria and across Africa with clean water, education, healthcare and rapid relief.</p>
                  <form className="footer-widget-two__form" onSubmit={(e) => e.preventDefault()}>
                    <div className="footer-widget-two__input">
                      <input type="email" placeholder="Your Email" />
                    </div>
                    <button type="submit" className="footer-widget-two__btn"><i className="icon-right-arrow"></i></button>
                  </form>
                </div>
              </div>
              <div className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="200ms">
                <div className="footer-widget-two__services">
                  <h4 className="footer-widget-two__title">Programs</h4>
                  <ul className="footer-widget-two__services-list list-unstyled">
                    <li><a href="/donations">Clean Water</a></li>
                    <li><a href="/donations">Education</a></li>
                    <li><a href="/donations">Healthcare</a></li>
                    <li><a href="/donations">Emergency Relief</a></li>
                  </ul>
                </div>
              </div>
              <div className="col-xl-2 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="300ms">
                <div className="footer-widget-two__links">
                  <h4 className="footer-widget-two__title">Links</h4>
                  <ul className="footer-widget-two__services-list list-unstyled">
                    <li><a href="/about">About</a></li>
                    <li><a href="/contact">Contact</a></li>
                    <li><a href="/donations">Donate</a></li>
                    <li><a href="/">Home</a></li>
                  </ul>
                </div>
              </div>
              <div className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="400ms">
                <div className="footer-widget-two__contact">
                  <h3 className="footer-widget-two__title">Contact Info</h3>
                  <ul className="footer-widget-two__contact-list list-unstyled">
                    <li>
                      <div className="icon"><span className="icon-call"></span></div>
                      <p><a href="tel:07063653772">07063653772</a></p>
                    </li>
                    <li>
                      <div className="icon"><span className="icon-email"></span></div>
                      <p><a href="mailto:info@rayyanaid.org">info@rayyanaid.org</a></p>
                    </li>
                    <li>
                      <div className="icon"><span className="icon-pin"></span></div>
                      <p>Abuja, Nigeria</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="site-footer-two__bottom">
          <div className="container">
            <div className="row">
              <div className="col-xl-12">
                <div className="site-footer-two__bottom-inner">
                  <div className="site-footer-two__copyright">
                    <p className="site-footer-two__copyright-text">© 2025 Rayyan Aid. All Rights Reserved. · Developed by <a href="https://syroltech.com" target="_blank" rel="noopener noreferrer" style={{ color: '#f59320' }}>Syrol</a></p>
                  </div>
                  <div className="site-footer-two__bottom-menu-box">
                    <ul className="list-unstyled site-footer-two__bottom-menu">
                      <li><a href="/about">Privacy Policy</a></li>
                      <li><a href="/about">Terms of Service</a></li>
                      <li><a href="/about">Cookies Settings</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default DonateFooter;
